export default "__VITE_ASSET__DjSMYpI3__"